require('./bootstrap')
require('../slug')
require('./vue/index')
require('../imageUploadPreview')
require('./responsiveTableDropdown')
require('./submitButtonDisabler')

const dtFormat = 'YYYY-MM-DD HH:mm'

$('.dateTimePicker').daterangepicker({
	singleDatePicker: true,
	showDropdowns: true,
	timePicker: true,
	timePickerSeconds: false,
	timePicker24Hour: true,
	locale: {
		format: dtFormat,
	}
})

$('.datePicker').daterangepicker({
	singleDatePicker: true,
	showDropdowns: true,
	timePicker: false,
	locale: {
		format: 'YYYY-MM-DD'
	}
})

$('.dtpicker-cancelable').daterangepicker({
	autoUpdateInput: false,
	singleDatePicker: true,
	showDropdowns: true,
	timePicker: true,
	timePickerSeconds: false,
	timePicker24Hour: true,
	locale: {
		cancelLabel: 'Clear',
		format: dtFormat,
	}
})

$('.dtpicker-cancelable').on('apply.daterangepicker', function(ev, picker) {
	$(this).val(picker.startDate.format(dtFormat))
})

$('.dtpicker-cancelable').on('cancel.daterangepicker', function(ev, picker) {
	$(this).val('')
})